export const getGenericContactList = state => {
    return state.list
}

export const getGenericContactDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/genericContact/getters.js